import { render, staticRenderFns } from "./ModalContactForm.vue?vue&type=template&id=03485f22&scoped=true&"
import script from "./ModalContactForm.vue?vue&type=script&lang=js&"
export * from "./ModalContactForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalContactForm.vue?vue&type=style&index=0&id=03485f22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03485f22",
  null
  
)

export default component.exports